export const DISPLAYED_FORMAT = 'DD/MM/YYYY';
